import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-modal',
    templateUrl: './custom-modal.component.html',
    styleUrls: ['./custom-modal.component.scss'],
    standalone: false
})
export class CustomModalComponent implements OnInit {
    @Input() show: boolean = false;


  constructor() { }

  ngOnInit() {
  }

}
